/* eslint-disable no-shadow */
enum EnumChartType {
  BubbleTree = 'bubbleTree',
  Radar = 'radar',
}

export default EnumChartType;
